import { useState } from 'react';
import { Modal as ModalDefault } from 'react-bootstrap';
import { ProposalService } from '../../../services';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import Modal from '../../Modal';
import FormMotivoRecusa from '../Action2/FormMotivoRecusa';
import './styles.scss';
import { useNavigate } from 'react-router-dom';

interface IProp {
  proposal: any;
}

const LostAction = ({ proposal }: IProp) => {
  const navigate = useNavigate();
  const [isLoad, setIsLoad] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const onSubmit = (_: boolean, motivo?: string) => {
    setIsLoad(true);

    const request = {
      id: proposal.id,
      aceito: false,
      motivo: motivo || "0",
    };

    ProposalService.postProposalContract(request)
      .then(() => {
        setShowModal(false);
        navigate(0)
      }).catch((_data) => {
        Modal.show({
          title: "Erro ao fechar proposta!",
          body: <p>{_data ?? ''}</p>,
          showCancel: true,
          showConfirm: false,
          onCancelText: "Fechar"
        });
      }).finally(() => {
        setIsLoad(false)
      });
  };

  return (
    <>
      {isLoad && <LoadingSpinner text='Carregando...' />}
      <button className="btn btn-danger d-block" style={{ paddingTop: 2, paddingBottom: 2, paddingLeft: 7, paddingRight: 7, marginTop: -4 }}
        onClick={() => setShowModal(true)}>Cancelar proposta</button>
      {
        <ModalDefault show={showModal}
          className={''}
          animation={false}
          backdrop="static"
          keyboard={false}
          style={{ zIndex: '1040' }}
        >
          <ModalDefault.Header>
            <ModalDefault.Title>{'Recusar proposta'}</ModalDefault.Title>
            <button type="button" className="close" data-dismiss="modal" aria-label="Fechar"
              onClick={() => setShowModal(false)}>
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalDefault.Header>
          <ModalDefault.Body>
            <FormMotivoRecusa onConfirm={onSubmit} />
          </ModalDefault.Body>
        </ModalDefault>
      }
    </>
  )
};

export default LostAction;
